<template>
    <md-list-item>
        <!-- AVATAR/IMAGE -->
        <md-avatar class="md-large">
            <img :src="orderItem.picture_b64"
                :alt="orderItem.picture_name">
        </md-avatar>

        <!--PRODUCT NAME + (CALIBER) -->
        <!-- QUANTITY + UNIT -->
        <!-- STATUS + (PREPARED) -->
        <div class="md-list-item-text">
            <span><b>{{ orderItem.product_name }}</b> ({{ orderItem.caliber }})</span>
            <span>{{ orderItem.quantity }} {{ orderItem.units }}</span>
            <span>{{ orderItem.product_status }} {{ orderItem.prepared ? '('+$t('orders.prepared')+')' : '' }}</span>
        </div>

        <div>
            <md-button class="md-icon-button md-list-action"
                @click="removeFromCart(index)"
                v-if="!inCheckout">
                <md-icon>delete</md-icon>
            </md-button>
        </div>
    </md-list-item>
</template>

<script>
import _ from 'lodash'
export default {
    name: 'MiniCartItem',

    props: {
        item: {
            type: Object,
            default: null
        },

        index: {
            type: Number,
            default: null
        },

        inCheckout: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            orderItem: {}
        }
    },

    methods: {
        removeFromCart (id) {
            this.$store.dispatch('removeFromCart', id)
        }
    },

    created () {
        this.orderItem = _.cloneDeep(this.item)
    }
}
</script>
